import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('common/auth', ['getAuth']),
    blocking() {
      return this.getAuth.token && this.getAuth.status == 206;
    },
  },
  methods: {
    showError(error) {
      if (error.response) {
        const message = error.response.data.message || error.message;
        this.$dialog.alert(message);
      }
    },
  },
};
